export const iconFontAwesomeLogisticsRoadCircleXmark = (
	<i className="fa-solid fa-road-circle-xmark"></i>
);
